import {Component, inject, Input} from '@angular/core';
import {TopBarComponent} from '../top-bar/top-bar.component';
import {AsyncPipe} from '@angular/common';
import {MatIcon} from '@angular/material/icon';
import {filter, finalize, map, switchMap, tap} from 'rxjs';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {ActivatedRoute, Router} from '@angular/router';
import {SupportApiService} from '../../services/support-api.service';

@Component({
  selector: 'app-ticket-reason',
  imports: [
    TopBarComponent,
    AsyncPipe,
    MatIcon
  ],
  templateUrl: './ticket-reason.component.html',
  styleUrl: './ticket-reason.component.scss'
})
export class TicketReasonComponent {
  private route: ActivatedRoute = inject(ActivatedRoute);
  private router: Router = inject(Router);
  private supportApiService: SupportApiService = inject(SupportApiService);

  public reasonsLoading = false;
  public planningStatus = this.route.snapshot.queryParamMap.get('planningStatus');



  public reasons$ = this.route.queryParamMap
    .pipe(
      tap(() => this.reasonsLoading = true),
      switchMap(params => {
        return this.supportApiService.getReasons().pipe(
          map(data => data?.data.filter(reason => reason.type === params.get('planningStatus'))),
          finalize(() => this.reasonsLoading = false));
      }),
      takeUntilDestroyed()
    );

  public openComment(id: string) {
    this.router.navigate(['/ticket-comment'], {queryParams: {
        ticket_uuid: this.route.snapshot.queryParamMap.get('ticket_uuid'),
        reason_id: id,
        planningStatus: this.planningStatus
    }
    });
  }
}
